import { defineMessages } from 'react-intl';

export default defineMessages({
    youEntered: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyGroup.(You Entered)',
        defaultMessage: '(You Entered)'
    },
    consumerReportsShow: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyGroup.(Consumer Reports Show)',
        defaultMessage: '(Consumer Reports Show)'
    },
    consumerReportHelpText:{
        id: 'ml.quoteandbind.pa.hvq.discrepancies.propertyGroup.consumerReportHelpText',
        defaultMessage: 'What are consumer reports? They are information provided by consumer reporting agencies that include your driving record, auto and home claim history and credit report.'
    }
});
